// extracted by mini-css-extract-plugin
module.exports = {"section":"TermsSection_section__F89nf","sectionTitle":"TermsSection_sectionTitle__8k0Dp"};